// extracted by mini-css-extract-plugin
module.exports = {"container":"tabs_container__3FLR9","tab":"tabs_tab__euk7l","active":"tabs_active__sMgxx"};